
<app-header-helena class="request-banner" bannerImage="sprayer-sky.webp"></app-header-helena>
<h1>Tankmix Request Form</h1>

<form [formGroup]="tankmixRequestForm">
  <div class="sideBySide">
    <div >
      <div class="form-group">
        <label for="nameTextBox">Name</label>
        <input
          type="text"
          id="nameTextBox"
          name="nameTextBox"
          formControlName="name"
          autocomplete="family-name"
          
        />
        <small class="form-text textmuted"></small>
      </div>
      <div class="form-group">
        <label for="emailTextBox">Email</label>
        <input type="email" id="emailTextBox" name="emailTextBox" 
         formControlName="email"
         
         />
        <small class="form-text textmuted"></small>
      </div>
      <div class="form-group">
        <label for="companyTextBox">Company</label>
        <input type="text" id="companyTextBox" name="companyTextBox"  formControlName="company" />
        <small class="form-text textmuted"></small>
      </div>
    </div>

    <div >
      <div class="form-group">
        <label for="requestDateTextBox">Request Date</label>
        <input
          type="text"
          id="requestDateTextBox"
          name="requestDateTextBox"
          
          formControlName="requestDate"
          bsDatePicker
        />
        <small class="form-text textmuted"></small>
      </div>
      <div class="form-group">
        <label for="countryDropDown">Country</label>
        <select id="countryDropDown" name="countryDropDown" 
         formControlName="country"
        
        >
          <option *ngFor="let choice of countryChoices" 
          [value]="choice.code + ' - ' + choice.name">{{ choice.name }}</option>
        </select>
       
      </div>
     
    </div>
  </div>
 
      <div class="form-group">
        <label for="commentsTextArea">Comments</label>
        <input type="text" id="commentsTextArea" name="commentsTextArea" 
         formControlName="comments" />
        <small class="form-text textmuted"></small>
      </div>
   <div class="alert alert-warning">

  

      <div class="header">
        <strong >General Guidance of Mixing Order</strong>
        </div>
        <ol>
          <li >Water Conditioners or anti-foam (if needed)</li>
          <li >Solid Micronutrients</li>
          <li>Solid crop protection products (eg wettable granules, solid granules, wettable powder)</li>
          <li >Water based crop protection products (eg  suspension concentrates, capsule suspensions)</li>
          <li >Suspension concentrate / liquid micronutrients</li>
          <li >Solvent based crop protection products (eg suspo emulsions, emulsion in water, oil dispersal, emulsion concentrates)</li>
          <li >Adjuvants (if needed)</li>
        </ol>
     
      </div>

      <div class="request-ingredient-table" >
        <div class="header">
          <span>Order of Addition</span>
          <span>Helena Product or agrochemical</span>
          <span>Application Rate</span>
          <span>Units</span>
          <span></span>
        </div>
<ng-container formArrayName="ingredients">
        <ng-container *ngFor="let ingredientForm of ingredients.controls; let i = index">
          <div  class="ingredientRow"   [formGroup]="ingredientForm" >
            <span  class="order-of-addition" >{{ i + 1 }}</span>
            <span>
              <input type="text" name="ingredientname" class="ingredientname" 
              formControlName="name"/>
              
            </span>
    
            <span><input type="number" name="applicationRate" class="applicationRate" 
              formControlName="applicationRate" />
            </span>
            <span>
              <select  name="applicationUnit" class="applicationUnit"
              formControlName="applicationUnit"
              >
              <option value="">-- Select Units --</option>  
              <option *ngFor="let choice of applicationUnitChoices">{{ choice }}</option>
              </select>
            </span>
            <span><button *ngIf="i > 1" class="btn-danger" (click)="deleteProduct(i)">Delete</button></span>
          </div>
        </ng-container>
      </ng-container>


      <div class="ingredientRow">
        <span class="water-wate" for="waterRateTextBox" i18n="@@WaterRate">Water Rate</span>
        <span></span>
        <span><input class="water-rate-textbox" type="number" id="waterRateTextBox" name="waterRateTextBox"
            formControlName="waterRate" min="0" />
        </span>
        <span>
          
        </span>
  
        <span></span>
      </div>
      </div>



  <button class="btn" (click)="addProduct()">Add Ingredient</button>
</form>

<div class="alert alert-warning">
  <p>
    <strong>IMPORTANT NOTE:</strong>
  </p>
  <p>
    Tank mixes are made for convenience of application only. The test results provided do not represent a guarantee of chemical and/or
    biological compatibility, nor crop safety of any tank mix. The test conducted and the conclusions drawn do not represent or imply an
    approval or recommendation for application of the mixture to any agricultural crop. It should be noted that agro - chemicals
    based on the same active ingredient may vary in concentration and formulation. This can affect the tank mixability. Active ingredient
    alone is no guarantee of the product's tank mix properties and therefore a result for an active ingredient should not be considered as a
    result for tank mixing other than for the specific product named with the specified country of origin. For further information on all
    aspects of tank mixing of our nutritional products with other agro-chemical products or compounds visit the Tankmix web site. Product
    does not recommend the mixing of its products with any other product or compound not included on the www.tankmix.com database. This
    information is correct at the time of printing and replaces all previous information relating to tank mixing. We reserve the right to
    update information regularly without prior notification.
  </p>
</div>

<button *ngIf="tankmixRequestForm.valid" class="btn-success" (click)="submitRequest()">Submit</button>

<p>
  <strong
    >Please ensure that application rates and water rates are included with your request. Read the notes at the bottom of page before acting
    on tank mix test results.</strong
  >
</p>
<div id="formedEmail" class="never-displayed">
  <h1>Details</h1>
  <table >
    <tr>
      <th>Name</th>
      <td>{{ currentValues.name }}</td>
      </tr><tr>
      <th>Email</th>
      <td>{{ currentValues.email }}</td>   </tr><tr>
      <th>Company</th>
      <td>{{ currentValues.company }}</td>   </tr><tr>
      <th>Request Date</th>
      <td>{{ currentValues.requestDate }}</td>   </tr><tr>
      <th>Country</th>
      <td>{{currentValues.country}}</td>   </tr><tr>
      <th>Water Rate</th>
      <td>{{ currentValues.waterRate }}</td>   </tr><tr>
      <th>Comments</th>
      <td>{{ currentValues.comments }}</td>   </tr><tr>
    
  </table>

  <h2>Composition</h2>

  <table class="">
    <thead></thead>
    <tr>
      <th>Order of Addition</th>
      <th>Product or agrochemical</th>
      <th>Application Rate</th>
      <th>Units</th>
    </tr>
    <tbody>
      <tr *ngFor="let ingredient of currentValues.ingredients; let i = index">
        <td>{{ i + 1 }}</td>
        <td>{{ ingredient.name }}</td>

        <td>{{ ingredient.applicationRate }}</td>
        <td>{{ ingredient.applicationUnit }}</td>
      </tr>
    </tbody>
  </table>
</div>
